import { mockBuilder } from '../../utils/builderHelper.es.js';
import { ArtistProfile } from './ArtistProfile.es.js';
import { aDspArtist } from './DspArtist.mock.es.js';

/** @module Mocks */ /** typedoc */
function anArtistProfile() {
    return mockBuilder(new ArtistProfile())
        .withId('default-artist-profile-id')
        .withName('Default Artist Profile')
        .withDspArtists([aDspArtist().withName('Default Artist Profile')]);
}

export { anArtistProfile };
